/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import XImg from "vux/src/components/x-img/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Actionsheet from "vux/src/components/actionsheet/index.vue"; // this line is trasformed by vux-loader
import Timeline from '@/components/Timeline';
import TimelineItem from '@/components/Timeline/TimelineItem';
import ExtField from '@/components/ExtField';
import UserLogo from '@/components/UserLogo';
import { apisystemsettingByCode } from '@/api';
export default {
  components: {
    XImg: XImg,
    ViewBox: ViewBox,
    Timeline: Timeline,
    TimelineItem: TimelineItem,
    ExtField: ExtField,
    UserLogo: UserLogo,
    Actionsheet: Actionsheet
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    orderInfo: {
      type: Object
    },
    coordList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    orderServiceNodes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    serviceTreeMap: {
      type: Object
    },
    isEditCoordination: Boolean
  },
  data: function data() {
    return {
      corpId: '',
      show: false,
      menus: {
        name: i18n.tc("611"),
        name2: i18n.tc("612")
      },
      is_hide_worker_phone: 0,
      is_customer_view_progress: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    coordListName: function coordListName() {
      return this.coordList.map(function (item) {
        return item.name;
      }).join('、');
    }
  }),
  created: function created() {
    var _this = this;
    apisystemsettingByCode({
      code: 40002
    }).then(function (res) {
      if (res.success) {
        _this.is_hide_worker_phone = +res.data.value;
      }
    });
    apisystemsettingByCode({
      code: 40003
    }).then(function (res) {
      if (res.success) {
        _this.is_customer_view_progress = +res.data.value;
      }
    });
  },
  methods: {
    // 打电话
    callPhone: function callPhone(phone) {
      if (this.$DingTalk) {
        this.$DingTalk.biz.telephone.showCallMenu({
          phoneNumber: phone,
          // 期望拨打的电话号码
          code: '+86',
          // 国家代号，中国是+86
          showDingCall: true,
          // 是否显示钉钉电话
          onSuccess: function onSuccess() {},
          onFail: function onFail() {}
        });
      }
    },
    clickMenus: function clickMenus(key, item) {
      if (item === i18n.tc("611")) {
        this.callGroupChat();
      } else if (item === i18n.tc("612")) {
        this.telMeeting();
      }
    },
    // 发起群聊
    callGroupChat: function callGroupChat() {
      if (this.coordList.length >= 3) {
        var list = [];
        this.coordList.forEach(function (item) {
          list.push(item.jobnumber);
        });
        var JSONObject = {
          users: list,
          // 用户列表,工号
          corpId: this.corpId // 企业id
        };
        this.$DingTalk.biz.util.open({
          name: 'chat',
          // 页面名称
          params: JSONObject,
          // 传参
          onSuccess: function onSuccess() {},
          onFail: function onFail() {}
        });
      } else {
        this.$vux.toast.text(i18n.tc("613"));
      }
    },
    // 电话会议
    telMeeting: function telMeeting() {
      if (this.coordList.length >= 3) {
        var list = [];
        this.coordList.forEach(function (item) {
          list.push(item.jobnumber);
        });
        this.$DingTalk.biz.telephone.call({
          users: list,
          // 用户列表，工号
          corpId: this.corpId,
          // 企业id
          onSuccess: function onSuccess() {},
          onFail: function onFail() {}
        });
      } else {
        this.$vux.toast.text(i18n.tc("613"));
      }
    }
  }
};